const tooltips = {
  agencyFee:
    "Set the fee you’re willing to pay a recruitment agency if you hire a candidate they introduce to you, as a percentage of salary. (Note, if you don’t hire a candidate you won’t pay any fees.)",
  salaryType: "You may specify a fixed salary or salary range.",
  interviewComments: "E.g. Technical test required before the interview.",
  mustHaves: "Type in a new item and press Enter.",
  notificationRecipients:
    "There must be at least one person receiving notifications for this job.",
  agencyBriefing:
    "The more information we can give to the agency, the better the quality of their candidates. An agency brief should detail any of the nitty-gritty not already on the spec that would be essential to finding the perfect candidate. For instance: your top three must-haves, the names of the companies that you would love to see on candidates CVs, where your best-performing employee came from, etc",
  audienceMembers:
    "Please add one or more recruiters from your PSL to the audience in order for them to be able to engage with this role.",
  burst:
    "Posting to marketplace allows HH agencies that are not on your PSL to view your vacancy and request to engage.",
  numberOfPositions:
    "Please select the number of positions you would like on this role.",
};

export { tooltips as default };
